/**
 * @packageDocumentation
 * @module f1/number
 */

export interface Clamp {
  /**
   * Keep a value between a minimum and maximum value
   *
   * @public
   * @function f1.clamp
   * @param min a minimum to limit the number by
   * @param max a maximum to limit the number by
   * @param v a real number
   * @example
   *
   * ```ts
   * clamp(0, 10, 5) === 5
   * clamp(0, 10, 15) === 10
   * clamp(0, 10, -5) === 0
   * ```
   */
  (min: number, max: number, v: number): number;
  /**
   * {@link FnClampValue}
   */
  (min: number, max: number): (v: number) => number;
}

/**
 * @see Clamp
 */
export default (min: number, max: number, v: number) => Math.min(max, Math.max(min, v));
